import { useCallback, useEffect, useState } from "react";
import { ChipStatus } from "../components/shared/ppr-chip-status/ppr-chip-status";
import { sleep } from "../components/util/util";

const DETECT_LIST = ["android", "iphone", "ipad", "mac", "windows", "linux"];
const MOBILE_DEVICE_LIST = ["android", "ios"];

export const useDeviceCheck = (shouldRun: boolean) => {
  const [deviceType, setDeviceType] = useState("Unknown");
  const [status, setStatus] = useState<ChipStatus>("not-started");

  const getDevice = useCallback(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const device =
      DETECT_LIST.find((name) => userAgent.includes(name)) ?? "unknown";

    if (["iphone", "ipad"].includes(device)) return "ios";
    return device;
  }, []);

  const isMobile = useCallback((device: string) => {
    return MOBILE_DEVICE_LIST.includes(device);
  }, []);

  useEffect(() => {
    const runDeviceCheck = async () => {
      setStatus("analyzing");
      await sleep();
      const detectedDevice = getDevice();
      setDeviceType(detectedDevice);

      if (isMobile(detectedDevice)) {
        setStatus("failed");
        setDeviceType("Mobile");
      } else {
        setStatus("passed");
        setDeviceType("Desktop");
      }
    };

    if (shouldRun) runDeviceCheck();
  }, [shouldRun]);

  return { deviceType, deviceCheckStatus: status };
};
